export const firstColor = "#004BBD";
export const secondColor = "#004BBD";
export const thirdColor = "#004BBD";
export const fourthColor = "#004BBD";

